import ArchitectureIcon from "@mui/icons-material/Architecture";
import ConstructionIcon from "@mui/icons-material/Construction";
import EngineeringIcon from "@mui/icons-material/Engineering";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CalculateIcon from "@mui/icons-material/Calculate";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CampaignIcon from "@mui/icons-material/Campaign";
import ForumIcon from "@mui/icons-material/Forum";
import ShareIcon from "@mui/icons-material/Share";
import MovieIcon from "@mui/icons-material/Movie";
import PaletteIcon from "@mui/icons-material/Palette";
import ComputerIcon from "@mui/icons-material/Computer";
import SchoolIcon from "@mui/icons-material/School";
import TranslateIcon from "@mui/icons-material/Translate";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import YardIcon from "@mui/icons-material/Yard";
import PetsIcon from "@mui/icons-material/Pets";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import EventIcon from "@mui/icons-material/Event";

export const serviceCategoryIcons = {
  architecture: ArchitectureIcon,
  construction: ConstructionIcon,
  engineering: EngineeringIcon,
  business: BusinessCenterIcon,
  accounting: CalculateIcon,
  finance: AccountBalanceWalletIcon,
  marketing: CampaignIcon,
  communication: ForumIcon,
  "social-media": ShareIcon,
  media: MovieIcon,
  "creative-design": PaletteIcon,
  technology: ComputerIcon,
  education: SchoolIcon,
  language: TranslateIcon,
  agriculture: AgricultureIcon,
  landscape: YardIcon,
  "animal-science": PetsIcon,
  nutrition: RestaurantIcon,
  "wellness-fitness": FitnessCenterIcon,
  hospitality: RoomServiceIcon,
  events: EventIcon,
};
